import React from "react";

import { MonitoringTableHeadPropsType } from "./MonitoringTableHeadTypes";

const MonitoringTableHead: React.FC<MonitoringTableHeadPropsType> = ({
  columns,
  showTooltip,
  moveTooltip,
  hideTooltip,
  HeaderHelpIcon,
}) => {
  return (
    <tr>
      {columns.map((col) => (
        <th key={col.key}>
          {col.helpTitle != null && col.helpText != null ? (
            <>
              {col.label}{" "}
              <HeaderHelpIcon
                title={col.helpTitle}
                text={col.helpText}
                showTooltip={showTooltip}
                moveTooltip={moveTooltip}
                hideTooltip={hideTooltip}
                className="ml-1"
              />
            </>
          ) : (
            col.label
          )}
        </th>
      ))}
    </tr>
  );
};

export default MonitoringTableHead;
